module.exports = __webpack_public_path__ + "img/seafood.6bf2a607.jpg";